import { IDashboardResponse } from '../../../../model/apm/dashboard/response/dashboard-response';

export type DashboardState = {
    data?: IDashboardResponse;
    loading: boolean;
    upcomingDays: number;
};

export enum ACTION_TYPES {
    setData = 'setData',
    setLoading = 'setLoading',
    setUpcomingDays = 'setUpcomingDays',
}

export const DashboardReducer = (state: DashboardState, action: any): DashboardState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setData:
            return { ...state, data: payload };
        case ACTION_TYPES.setLoading:
            return { ...state, loading: payload };
        case ACTION_TYPES.setUpcomingDays:
            return { ...state, upcomingDays: payload };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
